export default __webpack_public_path__ + "static/media/complementary--playground--g1.7cc32db1.png";